// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sharePDFContainer_X0nWT{
    height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
    embed{
        margin: 0;
        padding: 0;
        height: 100vh;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/SharePDF/SharePDF.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB;QACI,SAAS;QACT,UAAU;QACV,aAAa;QACb,WAAW;IACf;AACJ","sourcesContent":[".sharePDFContainer{\n    height: 100vh;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    embed{\n        margin: 0;\n        padding: 0;\n        height: 100vh;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sharePDFContainer": `sharePDFContainer_X0nWT`
};
export default ___CSS_LOADER_EXPORT___;
